import { render, staticRenderFns } from "./PosIdSortableHeader.vue?vue&type=template&id=cbbb0898&scoped=true&"
import script from "./PosIdSortableHeader.vue?vue&type=script&lang=js&"
export * from "./PosIdSortableHeader.vue?vue&type=script&lang=js&"
import style0 from "./PosIdSortableHeader.vue?vue&type=style&index=0&id=cbbb0898&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbbb0898",
  null
  
)

export default component.exports